module.exports = __webpack_public_path__ + "static/media/PROD_JW3.e0eb3b52.png";